/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ApiErrorAction, getMessageCode, MessageCode } from '@common/tech-shared';
import { Messages, SnackBarService } from '@ui';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { PostfachActions } from './postfach.actions';

@Injectable()
export class PostfachEffects {
  private readonly actions$ = inject(Actions);
  private readonly snackBarService = inject(SnackBarService);

  downloadAsPdfFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PostfachActions.downloadAsPdfFailed),
        tap((action: ApiErrorAction) => {
          if (getMessageCode(action.apiError) == MessageCode.USER_MANAGER_SERVICE_UNAVAILABLE) {
            this.snackBarService.showError(Messages.HTTP_USER_MANAGER_SERVICE_UNAVAILABLE);
          }
        }),
      ),
    { dispatch: false },
  );
}
